export const MILESTONES = [
  {
    year: "1983",
    description: "Nasce em Sorocaba, São Paulo, Brasil",
  },
  {
    year: "2005",
    description: "Bacharelado em Engenharia Mecânica - FACENS",
  },
  {
    year: "2012",
    description: "Adquire a carteira de Piloto Comercial de aeronaves",
  },
  {
    year: "2019",
    description: "Inicia Análise e Desenvolvimento de Sistemas - FATEC",
  },
  {
    year: "2020",
    description: "Participa da Maratona Behind the Code - IBM",
  },
  {
    year: "jan/2021 - nov/2022",
    description: "Desenvolvedor front-end - Cadmus",
  },
  {
    year: "mar/2021",
    description: "Vence o 1º Cadmus Hackathon",
  },
  {
    year: "nov/2022 até o presente",
    description: "Desenvolvedor front-end - IAV",
  },
];
